var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user === null)?_c('div',{staticStyle:{"text-align":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }